module.exports = __webpack_public_path__ + "assets/img/form1.7d517402.png";